module.exports = __webpack_public_path__ + "static/img/2ok.53f6701a.webp";